import styled, { css } from 'styled-components';

const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const TagContainer = styled.div`
  display: flex;
  max-width: 11cm;
  max-height: 9cm;
  width: 11cm;
  height: 9cm;
  flex-direction: column;
`

export const ContentHeader = styled.div`
  position: relative;
  border-top: 7px solid black;
  border-bottom: 2px solid black;
  border-right: 7px solid black;
  border-left: 7px solid black;
  padding: 0 1px;
  padding: 0 !important;
  margin: 0 !important;
  overflow-wrap: break-word;
  flex: 1;
  display: flex;
  ${css`
      ${({ styleProductIsNotFount }) => styleProductIsNotFount
    }
    `
  }
`

export const ContainerModelDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 83%;
`

export const ContainerNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  background-color: #000;
`

export const ContainerStorage = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 7px;
  padding-right: 10px;
  padding-left: 10px;
  width: 100%;
  background-color: ${({ isPallet }) => (isPallet ? '#fff' : '#000')};
  border-bottom: ${({ isPallet }) => (isPallet ? '3px solid #000' : 'none')};
`;

export const ContentBarcode = styled(Content)`
  border-top: 2.5px solid black;
  border-bottom: 2.5px solid black;
  border-right: 7.5px solid black;
  border-left: 7.5px solid black;
  flex: 1;
`

export const ContentBatch = styled(Content)`
  flex: 1;
  border-right: 5px solid black;
  border-left: 5px solid black;
  border-bottom: 5px solid black;
`

export const ContentBatchInfo = styled.div`
  border: 2.5px solid black;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const OperatorContentInfo = styled(ContentBatchInfo)`
  display: flex;
  align-items: center;
`

export const WrapperContentBatchInfo = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`

export const TagText = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  b {
      font-size: 13px;
  }
`
export const TagOperatorNameText = styled(TagText)`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  padding: 0px 10px;
`
